import {
    Button,
    CircularProgress,
    Container,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Box,
    Stack,
    Typography,
} from '@mui/material';
import PostItem from './PostItem';
import PostListHeader from './PostListHeader';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

const PostList = observer(({ route, fetchData, title, addLabel }) => {
  const navigate = useNavigate();
  const { posts } = useContext(Context);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const loadData = useCallback(async () => {
    setIsLoading(true);
    posts.setPosts([]);
    const data = await fetchData();
    if (Array.isArray(data) && data.length > 0) {
      posts.setPosts(data.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)));
      const uniqueBranches = [
        ...new Set(data.flatMap((post) => (post.branches || []).map((branch) => branch.name))),
      ];
      setBranches(uniqueBranches);
    }
    setIsLoading(false);
  }, [fetchData, posts]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (selectedBranch) {
      setFilteredPosts(
        posts.posts.filter((post) =>
          (post.branches || []).some((branch) => branch.name === selectedBranch)
        )
      );
    } else {
      setFilteredPosts([...posts.posts]);
    }
  }, [selectedBranch, posts.posts]);

  const addPostLabel = addLabel || (route?.includes('promotions') ? 'акцию' : 'новость');
  const addPostTitle = addPostLabel === 'акцию' ? 'Добавить акцию' : 'Добавить новость';

  return (
    <Box
      sx={{
        ml: { xs: 0, sm: '70px' },
        width: { sm: 'calc(100% - 70px)' },
        minHeight: 'calc(100vh - 70px)',
        p: 2,
        boxSizing: 'border-box',
      }}
    >
      {title && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      <PostListHeader
        left={
          <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
            <Typography variant="subtitle1">Фильтр</Typography>
            <FormControl sx={{ width: 242 }} size="small">
              <InputLabel id='branchLabel'>Филиал</InputLabel>
              <Select
                labelId='branchLabel'
                value={selectedBranch || ''}
                label='Филиал'
                onChange={(event) => setSelectedBranch(event.target.value)}
                size="small"
              >
                <MenuItem key={0} value=''>
                  Все
                </MenuItem>
                {branches.map((branch) => (
                  <MenuItem key={branch} value={branch}>
                    {branch}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        }
        right={
          <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
            <Typography variant="subtitle1">{addPostTitle}</Typography>
            <Button
              variant='contained'
              color='primary'
              size="small"
              onClick={() => navigate(route + '/new')}
              sx={{ height: 40, minHeight: 40, px: 2.5 }}
            >
              Добавить
            </Button>
          </Stack>
        }
      />

      {isLoading ? (
        <CircularProgress
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      ) : (
        <Container
          disableGutters
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 2,
            mt: 2,
          }}
        >
          {filteredPosts.map((post) => (
            <PostItem
              key={post.id}
              post={post}
              route={route}
              sx={{ flex: '0 1 calc(33.33% - 16px)', margin: '8px' }}
            />
          ))}
        </Container>
      )}
    </Box>
  );
});

export default PostList;
